//Contexte servant à l'authentification des utilisateurs.

import React, { useEffect, useState } from "react";
import { auth } from "../utils/config/firebase/index";
import { onAuthStateChanged } from "firebase/auth";
import Loading from "../components/utils/Loading";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setPending(false);
    });
  }, []);

  if (pending) {
    return <Loading />;
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
